import { createSlice } from "@reduxjs/toolkit";
import { TeacherResponseDto } from "../../shared/dtos/teacher/TeacherResponseDto";
import { TeacherSummaryDto } from "../../shared/dtos/teacher/TeacherSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const teacherSlice = createSlice({
  name: "teacher",
  initialState: getInitialCrudState<TeacherResponseDto, TeacherSummaryDto>(),
  reducers: {
    ...generateCrudReducers<TeacherResponseDto, TeacherSummaryDto>(),
  },
});

export const teacherActions = teacherSlice.actions;
export default teacherSlice.reducer;
